import React, { useContext } from 'react';
import Spreadsheet from 'react-spreadsheet';

import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

import { useFormattedTableData, updateChillerLogFieldIfChanged } from '../../../utils/highlightedDataUtil';

import { ChillerLog } from '../../model';

// TODO: We should abstract the Header, Additional, and Manufacturer Sections, since they're exactly the same, with the only difference being the _details that they refer to.

interface HeaderSubSectionProps {
  sectionChillerLog: ChillerLog;
  col: number;
}

const HeaderSubSection: React.FunctionComponent<HeaderSubSectionProps> = (props) => {
  let { sectionChillerLog, col } = props;

  let { chillerLog, setChillerLog, saveCurrentLogToLocalStorage, currentLogApproved, showRequiredFieldWarnings } =
    useContext(ChillerLogsContext);

  const handleSpreadsheetChange = (updatedData) => {
    updateChillerLogFieldIfChanged({
      chillerLog,
      setChillerLog,
      updatedData,
      getField: () => sectionChillerLog?.header_details,
      setField: (log, value) => {
        log.header_details = value;
      },
    });
  };

  let tableData = useFormattedTableData(
    sectionChillerLog?.header_details,
    col,
    currentLogApproved,
    showRequiredFieldWarnings,
  );
  let columnLabels = ['', '', '', ''];

  return (
    <Spreadsheet
      data={tableData}
      hideRowIndicators
      columnLabels={[columnLabels[col]]}
      onChange={handleSpreadsheetChange}
      className={col === 3 ? 'chiller-spreadsheet third-column' : 'chiller-spreadsheet'}
      onBlur={saveCurrentLogToLocalStorage}
    />
  );
};

export default HeaderSubSection;
